export default "__VITE_ASSET__xh1p7s$X__"